import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CrudService } from '../crud.service';
import { Observable } from 'rxjs';
import { IndicatorData } from '../../models/indicator-data';
import { ExportSheet } from './export-helper.service';

@Injectable({
  providedIn: 'root',
})
export class IndicatorDataService extends CrudService<IndicatorData> {
  protected basePath = 'indicator-data'; // Specific for IndicatorDataService
  public instanceType = 'indicator-data'; // Used in base service for constructing URLs

  updatePublishStatus(
    ids: string[],
    isLocked: boolean
  ): Observable<IndicatorData> {
    if (isLocked) {
      return this.http.put<IndicatorData>(
        `${this.getBaseUrl()}/publishMany`,
        ids
      );
    } else {
      return this.http.put<IndicatorData>(`${this.getBaseUrl()}/lockMany`, ids);
    }
  }

  /**
   * overwrite updateMultiple - invoke persistMany instead for IndicatorDatas
   * @param items
   */
  override updateMultiple(items: IndicatorData[]): Observable<IndicatorData> {
    return this.http.post<IndicatorData>(
      `${this.getBaseUrl()}/persistMany`,
      items
    );
  }

  getImportUrl(multipleYears: boolean) {
    return `${this.getBaseUrl()}/convertXlsxToJson?mode=${multipleYears ? 'multipleYears' : 'singleYear'}`;
  }

  convertToXlsx(IndicatorData: ExportSheet[], filename: string) {
    return this.http.post(
      `${this.getBaseUrl()}/convertJsonToXlsx`,
      { data: IndicatorData, filename: filename },
      {
        responseType: 'blob',
      }
    );
  }

  convertChartDataToXlsx(
    data: ExportSheet[],
    filename: string,
    source: string
  ) {
    return this.http.post(
      `${this.getBaseUrl()}/convertArrayToXlsx`,
      { data, filename, source },
      {
        responseType: 'blob',
      }
    );
  }

  findMany(
    dataLayerIds: string[],
    categoryIds: string[],
    filterByKeys?: string[]
  ) {
    const headers = new HttpHeaders({
      'X-Category-Ids': JSON.stringify(categoryIds),
      'X-DataLayer-Ids': JSON.stringify(dataLayerIds),
      'X-Filter-Keys': filterByKeys ? JSON.stringify(filterByKeys) : '',
    });
    return this.http.get<{ [key: string]: IndicatorData }>(
      `${this.getBaseUrl()}/findMany`,
      {
        headers: headers,
      }
    );
  }

  findByIndicatorIds(indicatorIds: string[]) {
    const headers = new HttpHeaders({
      'X-Indicator-Ids': JSON.stringify(indicatorIds),
    });
    return this.http.get<{ [key: string]: IndicatorData }>(
      `${this.getBaseUrl()}/findByIndicators`,
      {
        headers: headers,
      }
    );
  }

  constructor(http: HttpClient) {
    super(http);
  }
}
